<template>
    <v-container>
        <v-lov-dialog title="选择用户" :width="800" :fields="lovFields"
                      query-api="USER_QUERY"
                      v-model="showUserLovDialog"
                      @cancel="showUserLovDialog=false"
                      @ok="onAddRoleUser"></v-lov-dialog>
        <v-simple-form title="用户信息">
            <template v-slot:toolbar>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                    <v-icon color="gray">mdi-step-backward</v-icon>
                    返回
                </v-btn>
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                    <v-icon color="gray">mdi-content-save</v-icon>
                    保存
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-form-field x-large v-model="dataItem.roleName" label="角色名称"></v-form-field>
                <v-form-field x-large v-model="dataItem.roleCode" label="角色编码"></v-form-field>
                <v-form-textarea x-large v-model="dataItem.description" label="描述"></v-form-textarea>
            </template>
        </v-simple-form>
        <v-simple-form title="角色成员">
            <template v-slot:toolbar v-if="docId">
                <v-btn text tile small color="rgba(0,0,0,.7)" @click="showUserLovDialog=true">
                    <v-icon color="gray">mdi-plus-circle</v-icon>
                    添加成员
                </v-btn>
                <v-spacer/>
            </template>
            <template v-slot:content>
                <v-page-data-table
                        title=""
                        key-name="id"
                        ref="roleUser"
                        :fields="fields"
                        :show-edit="false"
                        :expand-row-column-count="1"
                        :query-params="queryParam"
                        delete-api="ROLE_USER_REMOVE"
                        query-api="ROLE_USER_LIST">
                </v-page-data-table>
            </template>
        </v-simple-form>


    </v-container>
</template>

<script>

    import FndRoleUserFields from "./fields/FndRoleUser";
    import FndRoleUserLovFields from "./fields/FndRoleUserLov";

    export default {
        name: "ProjectDetail.vue",
        data() {
            return {
                docId: null,
                fields: FndRoleUserFields,
                lovFields: FndRoleUserLovFields,
                showUserLovDialog: false,
                queryParam: {
                    roleId: this.$route.query.id
                },
                dataItem: {
                    id: null,
                    roleName: null,
                    roleCode: null,
                    description: null
                }
            }
        },
        created() {
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            onSave() {
                this.$request
                    .request("ROLE_APPLY", this.dataItem)
                    .then((response) => {
                        this.$message.success("保存成功");
                        if (!this.docId) {
                            this.docId = response.data;
                            this.dataItem.id = response.data;
                        }
                    });
            },

            queryDetail(id) {
                this.$request
                    .request("ROLE_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = response.data;
                    });
            },
            onAddRoleUser(item) {
                debugger
                let parameter = {
                    roleId: this.docId,
                    userId: item.id
                }
                this.$request
                    .request("ROLE_USER_ADD", parameter)
                    .then((response) => {
                        this.$refs.roleUser.query();
                    });
                this.showUserLovDialog = false;
            }
        }
    }
</script>
